module.exports = __webpack_public_path__ + "static/images/styles/images/icons/average-rating.RU.268f4b62.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/average-rating.RU.png
// module id = 3630
// module chunks = 11